import type { StyleProps } from "@ui/types";

export const styles = {
    footer: {
        bg: "black",
        flexDirection: "column",
        px: ["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"],
        pt: 2,
        minHeight: "332px",
    },
} satisfies Record<string, StyleProps>;
